import React, { Component } from "react";

import {
  Modal, DataTable
} from "@shopify/polaris";

// import utils from '../../utils/utils';

import Language from '../../i18n/Language';
const t = Language

class ImportRecordModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ImportRecordActive:props.ImportRecordActive,
      imrecordRows:props.imrecordRows
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.ImportRecordActive !== this.state.ImportRecordActive) {
      let ImportRecordActive = nextProps.ImportRecordActive;
      this.setState({
        ImportRecordActive: ImportRecordActive,
      })
    }
    if(nextProps.imrecordRows !== this.state.imrecordRows){
      this.setState({
        imrecordRows:nextProps.imrecordRows
      })
    }
    return true
  }

  //关闭Import Record窗口
  CloseImportRecord = () => {
    this.props.CloseImportRecord()
  };

  
  render() {

    return (
      <div style={{maxHeight: '400px'}} >
        <Modal
          open={this.state.ImportRecordActive}
          onClose={this.CloseImportRecord}
          title={t("Import Records")}
          secondaryActions={[
            {
              content: "Close",
              onAction: this.CloseImportRecord
            }
          ]}
          
        >
          <Modal.Section>
            {/* <TextContainer>
              * We will not import existing redirects,which is why sometimes the actual imported redirects is less than the redirects in the csv flie.
            </TextContainer> */}
            <DataTable
            columnContentTypes={[
              'text',
              'text',
              'text',
              'text',
              'text',
              'text',
            ]}
            headings={[
              t("File name"),
              t("Count"),
              t("Success/failed"),
              t("Status"),
              t("Import time"),
              t("Failed log"),
            ]}
            rows={this.state.imrecordRows}
          />
          </Modal.Section>
        </Modal>
      </div>
    );
  }
}

export default ImportRecordModel;